import { useState } from "react";
import { CARRIERS } from "@/utils";
import { useT } from "@/i18n_extra3";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const Logo = ({ name }) => {
  const [failed, setFailed] = useState(false);
  const slug = slugify(name);
  if (failed) {
    return <span className="font-display font-semibold text-xs text-black/55 px-2">{name}</span>;
  }
  return (
    <img
      src={`/assets/carriers/${slug}.png`}
      alt={name}
      loading="lazy"
      onError={() => setFailed(true)}
      className="max-h-9 max-w-[44px] object-contain"
    />
  );
};

const Ring = ({ items, radius, duration, reverse }) => (
  <div
    className={`orbit-ring ${reverse ? "orbit-ccw" : "orbit-cw"}`}
    style={{ "--dur": `${duration}s` }}
  >
    {items.map((c, i) => {
      const angle = (360 / items.length) * i;
      return (
        <div
          key={c}
          className="orbit-item"
          data-testid={`carrier-orbit-item-${slugify(c)}`}
          style={{ transform: `rotate(${angle}deg) translate(${radius}px)` }}
        >
          <div
            className={`orbit-card ${reverse ? "orbit-counter-ccw" : "orbit-counter-cw"}`}
            style={{ "--a": `${-angle}deg`, "--dur": `${duration}s` }}
          >
            <Logo name={c} />
          </div>
        </div>
      );
    })}
  </div>
);

export const CarrierBar = () => {
  const t = useT();
  const outer = CARRIERS.slice(0, 12);
  const inner = CARRIERS.slice(12);
  return (
    <section className="py-20 bg-[#FAF9F6] border-b border-black/5 overflow-hidden" data-testid="carrier-bar">
      <div className="text-center mb-4 px-5">
        <span className="text-[11px] font-bold tracking-[0.3em] uppercase text-black/40">{t.carriersLabel}</span>
      </div>

      {/* desktop: orbiting logos */}
      <div className="orbit-stage hidden lg:block mx-auto" data-testid="carrier-orbit">
        <div className="orbit-seal">
          <div className="orbit-seal-ring" />
          <img src="/assets/logo-icon.png" alt="ClearRoute" className="h-16 w-auto relative z-10" />
        </div>
        <Ring items={outer} radius={240} duration={70} />
        <Ring items={inner} radius={168} duration={48} reverse />
      </div>

      {/* mobile: floating grid */}
      <div className="lg:hidden grid grid-cols-3 gap-3 px-6 mt-6" data-testid="carrier-grid">
        {CARRIERS.map((c, i) => (
          <div key={c} className="orbit-chip" style={{ animationDelay: `${(i % 5) * 0.45}s` }}>
            <Logo name={c} />
          </div>
        ))}
      </div>
    </section>
  );
};
